// extracted by mini-css-extract-plugin
export default {"wrapper":"Bw-z","viewport":"Cw-z","container":"Dw-z","slide":"Ew-z"};